
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"23","width":"86","fill":"none","xmlns":"https://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.458 19.232l3.762-3.706c1.542 1.55 3.176 2.431 5.15 2.431 1.695 0 2.774-.85 2.774-2.157v-.061c0-1.368-1.264-2.187-3.516-2.187H28.1l-.863-3.069 4.965-4.405h-8.264v-4.77h15.602V5.53l-5.15 4.345c3.084.669 5.582 2.37 5.582 5.985v.06c0 4.314-3.516 7.08-8.325 7.08-4.163 0-7.092-1.49-9.189-3.768h.001zM65.617 1.231h5.581l8.881 11.242V1.23h5.92v21.267h-5.242l-9.22-11.666v11.666h-5.92V1.232zM11.44 18.442H.987L0 14.28 11.193 1.156h6.043v12.882h2.745v4.405h-2.745v4.132H11.44v-4.133zm0-4.375V7.961l-5.15 6.107h5.15zM42.45 11.926v-.062C42.45 5.667 47.29.806 53.827.806c4.41 0 7.247 1.823 9.158 4.436l-4.501 3.433c-1.234-1.52-2.651-2.49-4.718-2.49-3.022 0-5.15 2.521-5.15 5.62v.06c0 3.191 2.128 5.682 5.15 5.682 2.251 0 3.577-1.033 4.872-2.583l4.501 3.16c-2.035 2.765-4.779 4.8-9.559 4.8-6.167 0-11.132-4.648-11.132-10.998z","fill":"#fff"}})])
          )
        }
      }
    